module.exports = __webpack_public_path__ + "media/images/ecalls/card_star_tag-4b2bbf15376f312b4e7bfa24b3bc41a2.png";